






import xcPlanner from '@/assets/xcplanner.js'
export default {
  name: 'xc-planner',
  data() {
    return {
      map: null,
      movingMarker: false
    }
  },
  computed: {
    sync() {
      return this.$store.state.runtime.mapSync
    }
  },
  watch: {
    sync() {
      this.doSync()
    }
  },
  created() {
  },
  mounted() {
    if (this.$store.state.runtime.touchscreen) {
      alert(this.$pgettext('xc planner', 'XC Planner is an experimental feature.\nIt is only available from a computer, on meteo-parapente.com'))  // eslint-disable-line no-alert
      this.$store.dispatch('persistent/toggleXcplanner')
      return
    }
    if (window.google === undefined || window.google.maps === undefined) {
      const script = document.createElement('script')
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAeL75QTVdyogmANb1M0UKxcrE7LiCPqm0&libraries=geometry,places'
      script.onload = this.init
      const firstScript = document.getElementsByTagName('script')[0]
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      this.init()
    }
  },
  methods: {
    init() {
      xcPlanner(this.$pgettext, map => {
        this.map = map
        const backDiv = document.getElementById('map')
        const xcDiv = document.getElementById('xc-map')

        const events = [
          ['wheel', WheelEvent],
          ['click', MouseEvent],
          ['dblclick', MouseEvent],
          ['mousedown', MouseEvent],
          ['mouseup', MouseEvent]
          // ['mousemove', MouseEvent]
          /* ['touchstart', TouchEvent],
          ['touchend', TouchEvent],
          ['touchcancel', TouchEvent],
          ['touchend', TouchEvent],
          ['touchleave', TouchEvent],
          ['touchmove', TouchEvent] */
        ]
        // TODO : fix touch events

        events.forEach(event => {
          const name = event[0]
          const EventType = event[1]
          xcDiv.addEventListener(name, e => {
            // console.log(e.target.parentNode.className)
            if (name === 'mouseup') this.movingMarker = false
            if (e.target.tagName === 'AREA' && name !== 'wheel') {
              if (name === 'mousedown') this.movingMarker = true
              return
            }
            if (/control/.test(e.target.parentNode.className)) return
            if (/control/.test(e.target.parentNode.parentNode.className)) return
            const newEvent = new EventType(name, e)
            backDiv.dispatchEvent(newEvent)
          })
        })
        map.addListener('center_changed', () => {
          if (!this.movingMarker) return
          const center = map.getCenter()
          const zoom = map.getZoom()
          const lat = center.lat()
          const lon = center.lng()
          this.$store.dispatch('runtime/mapSync', {
            lat,
            lon,
            zoom
          })
        })
        this.doSync()
      })
    },
    doSync() {
      if (this.map === null) return
      if (this.movingMarker) return
      this.map.setCenter({
        lat: this.sync.lat,
        lng: this.sync.lon
      })
      this.map.setZoom(this.sync.zoom)
      this.map.panTo(this.map.getCenter())
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/xc-planner.vue